/* global gsap */

export default class BurgerButton {
	constructor() {
		this.buttonWrapper = document.querySelector('.burger-button-wrapper');
		if (!this.buttonWrapper) return;
		this.buttonLines = this.buttonWrapper.querySelectorAll('.burger-button span');
		this.offCanvas = document.getElementById(this.buttonWrapper.dataset.target);
		this.isWorking = false;
		this.events();
	}

	openButton() {
		const linesTl1 = new gsap.timeline();
		const linesTl2 = new gsap.timeline();

		linesTl1
			.to(this.buttonLines[0], {
				duration: 0.2,
				y: 10,
				ease: 'expo.inOut',
			})
			.to(this.buttonLines[0], {
				duration: 0.3,
				rotate: '-45deg',
				ease: 'expo.inOut',
			});

		gsap.to(this.buttonLines[1], {
			duration: 0.2,
			opacity: 0,
			ease: 'expo.inOut',
		});

		linesTl2
			.to(this.buttonLines[2], {
				duration: 0.2,
				y: -10,
				ease: 'expo.inOut',
			})
			.to(this.buttonLines[2], {
				duration: 0.3,
				rotate: '45deg',
				ease: 'expo.inOut',
			});
	}

	closeButton() {
		const linesTl1 = new gsap.timeline();
		const linesTl2 = new gsap.timeline();

		linesTl1
			.to(this.buttonLines[0], {
				duration: 0.3,
				rotate: 0,
				ease: 'expo.inOut',
			})
			.to(this.buttonLines[0], {
				duration: 0.2,
				y: 0,
				ease: 'expo.inOut',
			});

		gsap.to(this.buttonLines[1], {
			duration: 0.2,
			opacity: 1,
			ease: 'expo.inOut',
		});

		linesTl2
			.to(this.buttonLines[2], {
				duration: 0.3,
				rotate: 0,
				ease: 'expo.inOut',
			})
			.to(this.buttonLines[2], {
				duration: 0.2,
				y: 0,
				ease: 'expo.inOut',
			});
	}

	onBurgerButtonClicked() {
		if (this.isWorking) return false;
		this.isWorking = true;

		if (!this.offCanvas.classList.contains('active')) {
			this.openButton.bind(this)();
			this.offCanvas.dispatchEvent(new Event('burgerButton.open'));
		} else {
			this.closeButton.bind(this)();
			this.offCanvas.dispatchEvent(new Event('burgerButton.close'));
		}
		return true;
	}

	onMainMenuOpen() {
		this.isWorking = false;
	}

	onMainMenuClose() {
		this.isWorking = false;
	}

	events() {
		this.buttonWrapper.addEventListener('click', this.onBurgerButtonClicked.bind(this), false);
		window.addEventListener('mainMenu.open', this.onMainMenuOpen.bind(this), false);
		window.addEventListener('mainMenu.close', this.onMainMenuClose.bind(this), false);
	}

}
